angular.module('app').controller('ColorController', ColorController);

function ColorController($rootScope, $scope, $http) {
    $scope.deleteColor = function (id) {
        if (confirm('Biztosan törlöd ezt a színt?')) {
            var url = colorDeleteURL + '/' + id;
            $http.delete(url)
                .then(function successCallback(response) {
                    $('#row-' + id).transition('fade',250,function () {
                        $('#row-' + id).remove();
                    });

                }, function errorCallback(response) {
                    alert("Hiba történt törlés közben.");
                });
        }
    }
}
